import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'content', 'mark' ]

  connect() {
    this.setMarkIcon()
  }

  setMarkIcon() {
    const icon = (this.state === 'opened' ? 'expand_less' : 'expand_more')
    this.markTarget.innerText = icon
  }

  toggle() {
    if (this.state === 'opened') {
      this.contentTarget.classList.add('d-none')
    } else {
      this.contentTarget.classList.remove('d-none')
    }
    this.setMarkIcon()
  }

  get state() {
    return this.contentTarget.classList.contains('d-none') ? 'closed' : 'opened'
  }
}
